export const CREATE_OUT_OF_BUSINESS = 'CREATE_OUT_OF_BUSINESS'

export const CREATE_REDFLAG = 'CREATE_REDFLAG'
export const GET_REDFLAG = 'GET_REDFLAG'
export const UPDATE_REDFLAG = 'UPDATE_REDFLAG'
export const GET_ALL_REDFLAG = 'GET_ALL_REDFLAG'
export const DELETE_REDFLAG = 'DELETE_REDFLAG'
export const GET_ALL_OUTOFBUISNESS = 'GET_ALL_OUTOFBUISNESS'

export const CONTACT_LOADING = 'CONTACT_LOADING'
export const GET_CONTACT = 'GET_CONTACT'
export const GET_CONTACTS_TASK_ARE_ASSIGNED_TO = 'GET_CONTACTS_TASK_ARE_ASSIGNED_TO'
export const GET_ALL_CONTACTS = 'GET_ALL_CONTACTS'
export const UPDATE_CONTACT = 'UPDATE_CONTACT'
export const DELETE_CONTACT = 'DELETE_CONTACT'
export const DELETE_CONTACTS = 'DELETE_CONTACTS'
export const CREATE_CONTACT = 'CREATE_CONTACT'
export const CLEAR_CONTACTS = 'CLEAR_CONTACTS'
export const RESET_CONTACT = 'RESET_CONTACT'
export const RESET_DUPLICATED_CONTACTS = 'RESET_DUPLICATED_CONTACTS'
export const GET_CONTACTS_DIVISIONS = 'GET_CONTACTS_DIVISIONS'

export const GET_CONTACTS_ADDITIONAL = 'GET_CONTACTS_ADDITIONAL'
export const CREATE_CONTACTS_ADDITIONAL = 'POST_CONTACTS_ADDITIONAL'
export const UPDATE_CONTACTS_ADDITIONAL = 'UPDATE_CONTACTS_ADDITIONAL'
export const DELETE_CONTACTS_ADDITIONAL = 'DELETE_CONTACTS_ADDITIONAL'
export const GET_COMPANY_TYPE_OPTIONS = 'GET_COMPANY_TYPE_OPTIONS'
export const GET_DIVISIONS_COMBINED = 'GET_DIVISIONS_COMBINED'
export const SET_LOADER = 'SET_LOADER'
export const GET_DUPLICATED_CONTACTS = 'GET_DUPLICATED_CONTACTS'
export const GET_CONTACT_DIVISION = 'GET_CONTACT_DIVISION'
export const GET_RELATED_ENTITIES = 'GET_RELATED_ENTITIES'
export const SET_RELATED_ENTITIES_LOADING = 'SET_RELATED_ENTITIES_LOADING'

export const GET_HISTORY_DATA = 'GET_HISTORY_DATA'
export const GET_STATUS_CHANGES = 'GET_STATUS_CHANGES'

export const GET_PERSONAL_NOTES = 'GET_PERSONAL_NOTES'
export const LOADING_PERSONAL_NOTES = 'LOADING_PERSONAL_NOTES'

export const GET_LESSEE = 'GET_LESSEE'
export const CLEAR_LESSEE = 'CLEAR_LESSEE'
export const GET_ALL_LESSEE = 'GET_ALL_LESSEE'

export const CONTACT_ASSIGNED = 'CONTACT_ASSIGNED'
